import { useTranslation } from "react-i18next";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { Checkbox } from "../../../components/fields/base/Checkbox";
import { type BulkAdPlanModifierFormData } from "./BulkAdPlanModifierForm";

type Props = {
  formData: BulkAdPlanModifierFormData;
  setFormData: (data: BulkAdPlanModifierFormData) => void;
};

const BulkPlacementModifierManagementForm = ({ formData, setFormData }: Props) => {
  const { t } = useTranslation(["advertising"]);
  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className={css({ display: "flex", flexDirection: "column", alignItems: "center" })}
    >
      <p className={css({ padding: "large", textAlign: "center" })}>
        {t(
          ($) =>
            $.advertising[
              "Media plans with ROAS Boost or Growth Max optimizations selected are eligible for algorithmically managed placement multipliers."
            ],
        )}
      </p>
      <Flex justifyContent={"center"} width={"100%"} paddingBottom={"large"}>
        <Checkbox
          value={formData.algoManagedPlacementMultipliers}
          onChange={(checked) => {
            const updatedFormData = { ...formData, algoManagedPlacementMultipliers: checked };
            setFormData(updatedFormData);
          }}
          label={t(($) => $.advertising["Algorithmically Manage Placement Multipliers"])}
        />
      </Flex>
    </form>
  );
};

export default BulkPlacementModifierManagementForm;
